import React, { Component } from 'react';
import AuthTimers from '../components/login/authTimers';
 
class TimerController extends Component {
    render() {
        var ctrlrs = []
        ctrlrs.push(<AuthTimers key='auth' />)
        return (
            <div style={{ display: 'none' }}>
                {ctrlrs}
            </div>
        );
    }
}
 
export default TimerController;